import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { LicenseConnectorsListComponent } from '@portal-core/licenses/components/license-connectors/license-connectors-list/license-connectors-list.component';

@NgModule({
  declarations: [
    LicenseConnectorsListComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatIconModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    LicenseConnectorsListComponent
  ]
})
export class LicenseConnectorsListModule { }
